import React, { useState, useEffect } from "react";
import BotonManualHeader from "../../components/BotonManualHeader";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Alert,
  Spinner,
  Table,
} from "react-bootstrap";
import {
  collectionGroup,
  query,
  where,
  getFirestore,
  collection,
} from "firebase/firestore";
// getDocs instrumentado: informa cuántas lecturas hace esta pantalla para
// poder atribuir el consumo de Firestore a cada usuario (visible solo para superAdmin).
import { getDocs } from "../../functions/getDocsInstrumentado";
import { establecerOrigenConsumo } from "../../functions/consumoLecturas";
import { format } from "date-fns";
import { FaFileExcel, FaDownload } from "react-icons/fa";
import * as XLSX from "xlsx";
import firebaseApp from "../../firebase/credenciales";

const db = getFirestore(firebaseApp);

const ExportarMarcacionesExcel = ({ usuario }) => {
  const [rucEmpresa, setRucEmpresa] = useState(usuario?.ruc || "");
  const [selectedMonth, setSelectedMonth] = useState(
    format(new Date(), "yyyy-MM")
  );
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getString = (val) => String(val || "").trim();

  const encontrarEmpleado = (record, empList = employeeList) => {
    if (!record || !Array.isArray(empList) || empList.length === 0) return null;

    const candDni = getString(record.dni || record.metadata?.dni || record.metadata?.userDni);
    const candLegajo = getString(record.legajo || record.metadata?.legajo);
    const candLegajo2 = getString(record.legajo2 || record.metadata?.legajo2);

    const candidatos = [candDni, candLegajo, candLegajo2].filter(
      (v) => v && v.toLowerCase() !== "system"
    );
    if (candidatos.length === 0) return null;

    const matchCode = (cand, empCode) => {
      if (!empCode || !cand) return false;
      if (empCode === cand) return true;
      const cNorm = cand.replace(/\D/g, "");
      const eNorm = empCode.replace(/\D/g, "");
      if (!cNorm || !eNorm) return false;
      if (cNorm === eNorm) return true;
      if (cNorm.padStart(8, "0") === eNorm.padStart(8, "0")) return true;
      if (cNorm.padStart(10, "0") === eNorm.padStart(10, "0")) return true;
      if (cNorm.replace(/^0+/, "") === eNorm.replace(/^0+/, "")) return true;
      return false;
    };

    return empList.find((emp) => {
      const empDni = getString(emp.dni);
      const empLegajo = getString(emp.legajo);
      const empLegajo2 = getString(emp.legajo2);

      return candidatos.some((cand) => (
        matchCode(cand, empDni) ||
        matchCode(cand, empLegajo) ||
        matchCode(cand, empLegajo2)
      ));
    });
  };
  const [marcacionesData, setMarcacionesData] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const [grupos, setGrupos] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState("todos");
  const [grupoSeleccionado, setGrupoSeleccionado] = useState("todos");

  // Cargar empleados y grupos al iniciar
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        establecerOrigenConsumo("asistencia:exportar-marcaciones");
        // Cargar empleados de la colección 'users' (donde está el CECO)
        const empleadosRef = collection(db, "users");
        const empleadosQuery = query(empleadosRef, where("rucEmpresa", "==", rucEmpresa));
        const empleadosSnapshot = await getDocs(empleadosQuery);
        const empleados = [];
        empleadosSnapshot.forEach((doc) => {
          empleados.push({ id: doc.id, ...doc.data() });
        });
        setEmployeeList(empleados);

        // Cargar grupos
        const gruposRef = collectionGroup(db, "grupos");
        const gruposQuery = query(gruposRef, where("ruc", "==", rucEmpresa));
        const gruposSnapshot = await getDocs(gruposQuery);
        const gruposArr = [];
        gruposSnapshot.forEach((doc) => {
          const data = doc.data();
          gruposArr.push({
            id: doc.id,
            name: data.name,
            members: data.members || [],
          });
        });
        setGrupos(gruposArr);
      } catch (err) {
        console.error("Error al cargar datos iniciales:", err);
        setError("Error al cargar datos iniciales");
      }
    };

    if (rucEmpresa) {
      fetchInitialData();
    }
  }, [rucEmpresa]);

  // Función para cargar marcaciones
  const cargarMarcaciones = async () => {
    try {
      setLoading(true);
      setError(null);
      establecerOrigenConsumo("asistencia:exportar-marcaciones");

      // Obtener el rango de fechas para el mes seleccionado
      const [year, month] = selectedMonth.split("-");
      const fechaInicio = `${year}-${month.padStart(2, "0")}-01`;
      const fechaFin = `${year}-${month.padStart(2, "0")}-${new Date(
        year,
        month,
        0
      )
        .getDate()
        .toString()
        .padStart(2, "0")}`;

      // Consulta para obtener marcaciones
      const marcacionesQuery = query(
        collectionGroup(db, "registros"),
        where("ruc", "==", rucEmpresa),
        where("fechaJornada", ">=", fechaInicio),
        where("fechaJornada", "<=", fechaFin)
      );

      const marcacionesSnapshot = await getDocs(marcacionesQuery);
      let marcaciones = [];
      marcacionesSnapshot.forEach((doc) => {
        marcaciones.push({ id: doc.id, ...doc.data() });
      });

      // Filtrar por empleado si está seleccionado
      if (selectedEmployee !== "todos") {
        marcaciones = marcaciones.filter(record => record.dni === selectedEmployee);
      }

      // Filtrar por grupo si está seleccionado
      if (grupoSeleccionado !== "todos") {
        const grupo = grupos.find(g => g.id === grupoSeleccionado);
        if (grupo) {
          marcaciones = marcaciones.filter(record =>
            grupo.members.includes(record.dni)
          );
        }
      }

      // Ordenar por fecha y hora
      marcaciones.sort((a, b) => {
        const fechaA = new Date(`${a.fechaJornada}T${a.fechaMarcacion || '00:00'}`);
        const fechaB = new Date(`${b.fechaJornada}T${b.fechaMarcacion || '00:00'}`);
        return fechaA - fechaB;
      });

      setMarcacionesData(marcaciones);
    } catch (err) {
      console.error("Error al cargar marcaciones:", err);
      setError("Error al cargar las marcaciones. Por favor, intente nuevamente.");
    } finally {
      setLoading(false);
    }
  };

  // Función para exportar a Excel
  const exportarAExcel = () => {
    if (marcacionesData.length === 0) {
      setError("No hay datos para exportar. Primero cargue las marcaciones.");
      return;
    }

    try {
      // Preparar datos para Excel
      const datosExcel = marcacionesData.map(record => {
        // Buscar nombre del empleado por DNI, Legajo o Legajo 2
        const empleado = encontrarEmpleado(record, employeeList);

        return {
          'DNI': record.dni,
          'Nombre': empleado ? `${empleado.nombres} ${empleado.apellidoPaterno} ${empleado.apellidoMaterno}` : 'No encontrado',
          'Fecha': record.fechaJornada,
          'Tipo Marcación': record.tipo,
          'Hora': record.fechaMarcacion || (record.timestamp ? format(record.timestamp.toDate(), 'HH:mm') : ''),
          'Estado': record.activo === false ? 'Inactivo' : 'Activo',
          'Regularizado': record.regularizado ? 'Sí' : 'No',
          'Fecha/Hora Original': record.fechaHoraPeru || '',
          'Año': record.ano,
          'Período': record.periodo,
          'Timestamp': record.timestamp ? format(record.timestamp.toDate(), 'yyyy-MM-dd HH:mm:ss') : ''
        };
      });

      // Crear libro de Excel
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(datosExcel);

      // Configurar ancho de columnas
      const colWidths = [
        { wch: 10 }, // DNI
        { wch: 30 }, // Nombre
        { wch: 12 }, // Fecha
        { wch: 20 }, // Tipo Marcación
        { wch: 8 },  // Hora
        { wch: 10 }, // Estado
        { wch: 12 }, // Regularizado
        { wch: 20 }, // Fecha/Hora Original
        { wch: 6 },  // Año
        { wch: 8 },  // Período
        { wch: 20 }  // Timestamp
      ];
      ws['!cols'] = colWidths;

      // Agregar hoja al libro
      XLSX.utils.book_append_sheet(wb, ws, `Marcaciones_${selectedMonth}`);

      // Generar nombre del archivo
      const nombreArchivo = `marcaciones_${rucEmpresa}_${selectedMonth}.xlsx`;

      // Descargar archivo
      XLSX.writeFile(wb, nombreArchivo);

      setError(null);
    } catch (err) {
      console.error("Error al exportar a Excel:", err);
      setError("Error al generar el archivo Excel. Por favor, intente nuevamente.");
    }
  };

  return (
    <Container fluid className="py-4">
      <Card
        className="shadow-lg border-0"
        style={{ borderRadius: "15px", overflow: "hidden", minHeight: "90vh" }}
      >
        {/* Header Premium con degradado verde oscuro */}
        <Card.Header
          className="text-white py-4 position-relative"
          style={{
            background: "linear-gradient(135deg, #0d4f3c 0%, #2c7a2c 100%)",
            borderBottom: "3px solid #f39c12",
            borderRadius: "15px 15px 0 0",
          }}
        >
          <div
            className="position-absolute end-0 top-50 translate-middle-y me-4"
            style={{ zIndex: 10 }}
          >
            <BotonManualHeader usuario={usuario} />
          </div>
          <div className="text-center">
            <h2 className="fw-bold mb-1">
              <FaFileExcel className="me-3" />
              Exportar Marcaciones a Excel
            </h2>
            <p className="mb-0 opacity-75">
              Genera reportes de marcaciones personalizados en formato Excel | RUC:{" "}
              {rucEmpresa}
            </p>
          </div>
        </Card.Header>

        <Card.Body className="p-4" style={{ backgroundColor: "#f8f9fa" }}>
          {/* Acciones Rápidas */}
          <Card
            className="border-0 mb-4"
            style={{
              background: "linear-gradient(135deg,#fffcea,#fff9db)",
              borderRadius: 14,
              boxShadow: "0 2px 12px rgba(109,40,217,.07)",
            }}
          >
            <Card.Body className="p-3 d-flex justify-content-center gap-3 flex-wrap">
              <Button
                variant="outline-dark"
                onClick={cargarMarcaciones}
                disabled={loading}
                className="d-flex align-items-center gap-2 bg-white"
                style={{
                  borderRadius: "10px",
                  padding: "10px 20px",
                  fontWeight: "bold",
                }}
              >
                <FaDownload className={loading ? "fa-spin" : ""} size="16px" />
                Cargar Marcaciones
              </Button>
              <Button
                variant="success"
                onClick={exportarAExcel}
                disabled={loading || marcacionesData.length === 0}
                className="d-flex align-items-center gap-2"
                style={{
                  borderRadius: "10px",
                  background: "linear-gradient(135deg, #28a745 0%, #20c997 100%)",
                  border: "none",
                  padding: "10px 20px",
                  fontWeight: "bold",
                  boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                }}
              >
                <FaFileExcel size="16px" />
                Exportar a Excel (.xlsx)
              </Button>
            </Card.Body>
          </Card>

          {error && (
            <Alert variant="danger" onClose={() => setError(null)} dismissible>
              {error}
            </Alert>
          )}

          <Row className="mb-4 g-3 align-items-center bg-white p-3 mx-0 rounded-4 shadow-sm">
            <Col md={3}>
              <Form.Group>
                <Form.Label>Período</Form.Label>
                <Form.Control
                  type="month"
                  value={selectedMonth}
                  onChange={(e) => setSelectedMonth(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label>Empleado</Form.Label>
                <Form.Select
                  value={selectedEmployee}
                  onChange={(e) => setSelectedEmployee(e.target.value)}
                >
                  <option value="todos">Todos los empleados</option>
                  {employeeList.map((emp) => (
                    <option key={emp.dni} value={emp.dni}>
                      {emp.nombres} {emp.apellidoPaterno} {emp.apellidoMaterno} ({emp.dni})
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label>Grupo</Form.Label>
                <Form.Select
                  value={grupoSeleccionado}
                  onChange={(e) => setGrupoSeleccionado(e.target.value)}
                >
                  <option value="todos">Todos los grupos</option>
                  {grupos.map((grupo) => (
                    <option key={grupo.id} value={grupo.id}>
                      {grupo.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={3} className="d-flex align-items-end">
              <Button
                variant="primary"
                onClick={cargarMarcaciones}
                disabled={loading}
                className="me-2"
              >
                {loading ? <Spinner animation="border" size="sm" /> : <FaDownload />}
                {' '}Cargar Marcaciones
              </Button>
              <Button
                variant="success"
                onClick={exportarAExcel}
                disabled={marcacionesData.length === 0}
              >
                <FaFileExcel /> Exportar Excel
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {error && (
        <Alert variant="danger" className="mt-3">
          {error}
        </Alert>
      )}

      {marcacionesData.length > 0 && (
        <Card className="mt-4">
          <Card.Header>
            <h5>Vista Previa de Datos ({marcacionesData.length} registros)</h5>
          </Card.Header>
          <Card.Body>
            <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
              <Table striped bordered hover size="sm">
                <thead>
                  <tr>
                    <th>DNI</th>
                    <th>Nombre</th>
                    <th>Fecha</th>
                    <th>Tipo</th>
                    <th>Hora</th>
                    <th>Estado</th>
                    <th>Regularizado</th>
                  </tr>
                </thead>
                <tbody>
                  {marcacionesData.slice(0, 50).map((record, index) => {
                    const empleado = encontrarEmpleado(record, employeeList);
                    return (
                      <tr key={index}>
                        <td>{record.dni}</td>
                        <td>{empleado ? `${empleado.nombres} ${empleado.apellidoPaterno} ${empleado.apellidoMaterno}` : 'No encontrado'}</td>
                        <td>{record.fechaJornada}</td>
                        <td>{record.tipo}</td>
                        <td>{record.fechaMarcacion || (record.timestamp ? format(record.timestamp.toDate(), 'HH:mm') : '')}</td>
                        <td>{record.activo === false ? 'Inactivo' : 'Activo'}</td>
                        <td>{record.regularizado ? 'Sí' : 'No'}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              {marcacionesData.length > 50 && (
                <p className="text-muted mt-2">
                  Mostrando 50 de {marcacionesData.length} registros. El archivo Excel contendrá todos los registros.
                </p>
              )}
            </div>
          </Card.Body>
        </Card>
      )}
    </Container>
  );
};

export default ExportarMarcacionesExcel;